export default __webpack_public_path__ + "static/media/hero-image-3.c3efe2e4.png";